import React from 'react';
import './Voicemail.css';

export const Voicemail = ({ voicemail }) => {
    const { caller, recipient, timestamp, transcript } = voicemail;
    
    return (
        <div className="voicemail-container">
            <div className="voicemail-header">
                <div className="voicemail-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                </div>
                <div className="voicemail-details">
                    <div className="voicemail-label">Voicemail</div>
                    <div className="voicemail-metadata">
                        <div className="voicemail-from">
                            <span className="voicemail-meta-label">From:</span> {caller}
                        </div>
                        <div className="voicemail-to">
                            <span className="voicemail-meta-label">To:</span> {recipient}
                        </div>
                        {timestamp && (
                            <div className="voicemail-timestamp">
                                <span className="voicemail-meta-label">Time:</span> {timestamp}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="voicemail-body">
                <div className="voicemail-transcript-label">Transcript:</div>
                <div className="voicemail-transcript">
                    {transcript.split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}; 